import React, { useMemo } from "react";
import { isMobile } from "../store/user";

export function useWidgetIconStyle(widgetSettings: any) {
  return useMemo(() => {
    const iconSize = isMobile()
      ? widgetSettings?.appearance?.iconSize?.mobile
      : widgetSettings?.appearance?.iconSize?.desktop;

    const positionSettings = isMobile()
      ? widgetSettings?.position?.widgetPositionClosed?.mobile
      : widgetSettings?.position?.widgetPositionClosed?.desktop;

    const exactEnabled = positionSettings?.exactPositionEnabled;
    const exactPos = positionSettings?.exactPosition;

    const fallbackPosition =
      typeof positionSettings?.position === "number"
        ? positionSettings.position
        : isMobile()
          ? 5
          : 8;

    const gridMapDesktop: Record<number, React.CSSProperties> = {
      0: { top: "20px", left: "20px" },
      1: { top: "20px", left: "50%", transform: "translateX(-50%)" },
      2: { top: "20px", right: "20px" },
      3: { top: "70%", left: "20px", transform: "translateY(-50%)" },
      4: { top: "70%", left: "50%", transform: "translate(-50%, -50%)" },
      5: { top: "70%", right: "20px", transform: "translateY(-50%)" },
      6: { bottom: "20px", left: "20px" },
      7: { bottom: "20px", left: "50%", transform: "translateX(-50%)" },
      8: { bottom: "20px", right: "20px" },
    };

    const gridMapMobile: Record<number, React.CSSProperties> = {
      0: { top: "20px", left: "20px" },
      1: { top: "20px", right: "20px" },
      2: { top: "50%", left: "20px", transform: "translateY(-50%)" },
      3: { top: "50%", right: "20px", transform: "translateY(-50%)" },
      4: { bottom: "20px", left: "20px" },
      5: { bottom: "20px", right: "20px" },
    };

    const gridMap = isMobile() ? gridMapMobile : gridMapDesktop;

    const widgetIconStyle: React.CSSProperties = {
      width: `${iconSize}px`,
      height: `${iconSize}px`,
      position: "fixed",

      ...(exactEnabled && exactPos
        ? {
            ...(exactPos.horizontalAnchor === "left"
              ? { left: exactPos.horizontalDistance }
              : exactPos.horizontalAnchor === "right"
                ? { right: exactPos.horizontalDistance }
                : {}),

            ...(exactPos.verticalAnchor === "top"
              ? { top: exactPos.verticalDistance }
              : exactPos.verticalAnchor === "bottom"
                ? { bottom: exactPos.verticalDistance }
                : {}),
          }
        : gridMap[fallbackPosition]),
    };

    return {
      widgetIconStyle,
      iconSize,
      exactEnabled,
      exactPos,
      fallbackPosition,
    };
  }, [widgetSettings]);
}
